/**
 * Conditional variant picker: show/hide option dropdowns or swatches based on previous selection.
 * Option wrappers with data-conditional-show-when-option and data-conditional-show-values are
 * shown only when the referenced option's value is in the comma-separated list.
 */
(function() {
    function getCurrentOptionValues(picker) {
        const variantEl = picker.querySelector('variant-selects, variant-radios');
        if (!variantEl) return [];
        if (variantEl.querySelector('select')) {
            return Array.from(variantEl.querySelectorAll('select'), function(s) { return s.value; });
        }
        const fieldsets = variantEl.querySelectorAll('fieldset[data-option-index]');
        return Array.from(fieldsets, function(fs) {
            const checked = fs.querySelector('input:checked');
            return checked ? checked.value : '';
        });
    }

    function setOptionValue(picker, optionIndex, value, variantData) {
        const variantEl = picker.querySelector('variant-selects, variant-radios');
        if (!variantEl) return;
        if (variantEl.querySelector('select')) {
            const select = variantEl.querySelectorAll('select')[optionIndex];
            if (select && value) {
                select.value = value;
                variantEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
        }
        const fieldsets = variantEl.querySelectorAll('fieldset[data-option-index]');
        const fieldset = fieldsets[optionIndex];
        if (!fieldset || !value) return;
        const inputs = fieldset.querySelectorAll('input[type="radio"]');
        const input = Array.from(inputs).find(function(inp) { return inp.value === value; });
        if (input && !input.checked) {
            input.checked = true;
            variantEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    function getFirstValidValueForOption(variantData, optionIndex, optionsSoFar) {
        for (let i = 0; i < variantData.length; i++) {
            const v = variantData[i];
            let match = true;
            for (let j = 0; j < optionIndex; j++) {
                if (v.options[j] !== optionsSoFar[j]) {
                    match = false;
                    break;
                }
            }
            if (match && v.options[optionIndex]) return v.options[optionIndex];
        }
        return null;
    }

    function updateConditionalVisibility(picker) {
        const variantEl = picker.querySelector('variant-selects, variant-radios');
        if (!variantEl) return;
        let variantData;
        try {
            const jsonEl = variantEl.querySelector('[type="application/json"]');
            variantData = jsonEl ? JSON.parse(jsonEl.textContent) : [];
        } catch (e) {
            variantData = [];
        }
        const currentValues = getCurrentOptionValues(picker);
        const wrappers = picker.querySelectorAll('.product-form__option-wrapper[data-conditional-show-when-option][data-conditional-show-values]');
        wrappers.forEach(function(wrapper) {
            const showWhenOptionIndex = parseInt(wrapper.getAttribute('data-conditional-show-when-option'), 10);
            const showValuesStr = (wrapper.getAttribute('data-conditional-show-values') || '').trim();
            const showValues = showValuesStr ? showValuesStr.split(',').map(function(s) { return s.trim(); }) : [];
            const optionIndex = parseInt(wrapper.getAttribute('data-option-index'), 10);
            const refValue = (currentValues[showWhenOptionIndex] || '').trim();
            const shouldShow = showValues.length === 0 || showValues.some(function(v) { return v === refValue; });
            if (shouldShow) {
                wrapper.style.display = '';
                wrapper.removeAttribute('hidden');
            } else {
                wrapper.style.display = 'none';
                wrapper.setAttribute('hidden', '');
                var firstValid = getFirstValidValueForOption(variantData, optionIndex, currentValues.slice(0, optionIndex));
                if (firstValid) setOptionValue(picker, optionIndex, firstValid, variantData);
            }
        });
    }

    function initConditionalPickers() {
        document.querySelectorAll('[data-conditional-variant-picker]').forEach(function(picker) {
            const variantEl = picker.querySelector('variant-selects, variant-radios');
            if (!variantEl) return;
            updateConditionalVisibility(picker);
            variantEl.addEventListener('change', function() {
                updateConditionalVisibility(picker);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initConditionalPickers);
    } else {
        initConditionalPickers();
    }
    document.addEventListener('shopify:section:load', initConditionalPickers);
})();
